var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwFoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6593 1.61405C16.0584 1.88777 15.4181 2.06921 14.7506 2.15731C15.4373 1.73151 15.9615 1.0624 16.2079 0.255898C15.5676 0.652331 14.8607 0.932351 14.1073 1.08862C13.4993 0.416359 12.6328 0 11.6875 0C9.85349 0 8.37698 1.54588 8.37698 3.44099C8.37698 3.71367 8.3992 3.97586 8.45374 4.22547C5.69968 4.08598 3.26274 2.71525 1.62566 0.627161C1.33985 1.1421 1.17221 1.73151 1.17221 2.36601C1.17221 3.55741 1.76301 4.61351 2.64366 5.22494C2.11143 5.21445 1.5893 5.05399 1.14696 4.80124C1.14696 4.81173 1.14696 4.82536 1.14696 4.839C1.14696 6.51073 2.29524 7.89929 3.80103 8.21916C3.53138 8.29572 3.2375 8.33243 2.9325 8.33243C2.72042 8.33243 2.50631 8.31984 2.30534 8.2737C2.73456 9.63604 3.95252 10.6376 5.40075 10.6701C4.27367 11.5857 2.84262 12.1373 1.2934 12.1373C1.02173 12.1373 0.76117 12.1248 0.50061 12.0901C1.96803 13.0728 3.70711 13.6339 5.58253 13.6339C11.6784 13.6339 15.0112 8.39011 15.0112 3.84477C15.0112 3.6927 15.0061 3.54587 14.999 3.40009C15.6565 2.91556 16.2089 2.31043 16.6593 1.61405Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwFoot);
export default __webpack_public_path__ + "static/media/tw-foot.dfa5abc81b93c1fcaf25687d6a96653e.svg";
export { ForwardRef as ReactComponent };